import DepartmentsStore from './DepartmentsStore';
export * from './DepartmentsStore';
export default DepartmentsStore;
